import TransactionDetailsModal from '../../../banking/components/spaces/transactions/TransactionDetailsModal';

const TransactionDetailsScreen = () => {
    return <TransactionDetailsModal />;
};

export default TransactionDetailsScreen;
